export default __webpack_public_path__ + "static/media/order.6207c91e.png";